import { render, staticRenderFns } from "./PatentBasicInfo.vue?vue&type=template&id=945d3cd4&scoped=true"
import script from "./PatentBasicInfo.vue?vue&type=script&lang=js"
export * from "./PatentBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./PatentBasicInfo.vue?vue&type=style&index=0&id=945d3cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945d3cd4",
  null
  
)

export default component.exports